import { lazy } from 'react';
import { Navigate } from 'react-router';
import { TearsheetsIcon } from '@hf/designSystem/v1';
import type { SpaDefinition } from '@core/routes';
import { FEATURE_FLAG_KEYS } from '@core/utils/flags';
import { TearsheetsGate } from './layout/TearsheetsGate';
import { tearsheetsPaths } from './layout/tearsheetsPaths';

export { tearsheetsPaths };

const TearsheetsLayout = lazy(async () => {
  const mod = await import('./layout/TearsheetsLayout');
  return { default: mod.TearsheetsLayout };
});
const TearsheetsPage = lazy(async () => {
  const mod = await import('./pages/TearsheetsPage');
  return { default: mod.TearsheetsPage };
});
const TearsheetsCreatePage = lazy(async () => {
  const mod = await import('./pages/CreatePage');
  return { default: mod.TearsheetsCreatePage };
});
const TearsheetsViewPage = lazy(async () => {
  const mod = await import('./pages/ViewPage');
  return { default: mod.TearsheetsViewPage };
});
const TearsheetsBuilderPage = lazy(async () => {
  const mod = await import('./pages/BuilderPage');
  return { default: mod.TearsheetsBuilderPage };
});
const TearsheetsBrandingPage = lazy(async () => {
  const mod = await import('./pages/BrandingPage');
  return { default: mod.TearsheetsBrandingPage };
});

function TearsheetsProductLayout() {
  return (
    <TearsheetsGate>
      <TearsheetsLayout />
    </TearsheetsGate>
  );
}

export const tearsheetsSpa = {
  key: 'tearsheets',
  path: '/tearsheets',
  label: 'Tearsheets',
  icon: <TearsheetsIcon />,
  public: false,
  nav: 'main',
  trackRecent: true,
  featureFlag: FEATURE_FLAG_KEYS.tearsheets,
  paths: tearsheetsPaths,
  layout: <TearsheetsProductLayout />,
  children: [
    { index: true, element: <TearsheetsPage /> },
    { path: tearsheetsPaths.create, element: <TearsheetsCreatePage /> },
    { path: tearsheetsPaths.viewReport, element: <TearsheetsViewPage /> },
    { path: tearsheetsPaths.builder, element: <TearsheetsBuilderPage /> },
    { path: tearsheetsPaths.archive, element: <Navigate to=".." replace /> },
    { path: tearsheetsPaths.branding, element: <TearsheetsBrandingPage /> },
  ],
} as const satisfies SpaDefinition;
